import { ClientType } from '@core/domain/model/user/auth-user.model';
import { AllRouteNamesType } from 'src/app/app.routes';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { HeaderNotification } from '@core/domain/model/notifications/notification.model';

export const navLinks: Array<{
  route: Array<AllRouteNamesType>;
  label: string;
  userType: Array<ClientType>;
  notification?: HeaderNotification;
}> = [
  {
    route: AcRoutingService.HOME_ROUTE(),
    label: 'ROUTES.HOME',
    userType: ['GGCC', 'PYMES'],
  },
  {
    route: AcRoutingService.MY_SERVICES_LISTING_ROUTE(),
    label: 'ROUTES.SERVICES',
    userType: ['GGCC', 'PYMES'],
  },
  {
    route: AcRoutingService.MY_INVOICES_LISTING_ROUTE(),
    label: 'ROUTES.INVOICES',
    userType: ['GGCC', 'PYMES'],
    notification: HeaderNotification.INVOICES,
  },
  {
    route: AcRoutingService.MY_CONSUMPTION_ROUTE(),
    label: 'ROUTES.MY_CONSUMPTION',
    userType: ['GGCC', 'PYMES'],
  },
  {
    route: AcRoutingService.MY_PROCEDURES_LISTING_ROUTE(),
    label: 'ROUTES.PROCEDURES',
    userType: ['GGCC', 'PYMES'],
    notification: HeaderNotification.PROCEDURES,
  },
  {
    route: AcRoutingService.SUSTAINABILITY_ROUTE(),
    label: 'ROUTES.SUSTAINABILITY',
    userType: ['GGCC'],
  },
  {
    route: AcRoutingService.MARKET_ROUTE(),
    label: 'ROUTES.MARKET',
    userType: ['GGCC'],
  },
];
